export default "__VITE_ASSET__8a6O9gWc__"